export const ASCENDING_ORDER = 'ASC';
export const DESCENDING_ORDER = 'DESC';

export const SORT_ORDER_OPTIONS = {
  [ASCENDING_ORDER]: 'asc',
  [DESCENDING_ORDER]: 'desc',
};

export default SORT_ORDER_OPTIONS;
